import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import createBottomSheetSlice from './slices/bottomSheetSlice';
import createLocationSlice from './slices/locationSlice';
import createModalSlice from './slices/modalSlice';
import type { BoundStore } from './slices/store.types';

const useBoundStore = create<BoundStore>()(
	persist(
		immer((...a) => ({
			...createModalSlice(...a),
			...createLocationSlice(...a),
			...createBottomSheetSlice(...a),
		})),
		{
			name: 'mantang-storage',
			partialize: ({
				currentSnapPoint: _currentSnapPoint,
				dispatch: _dispatch,
				isModalOpen: _isModalOpen,
				modalConfig: _modalConfig,
				...state
			}) => state,
		},
	),
);

export default useBoundStore;
